import { createFileRoute } from "@tanstack/react-router";
import { useState, type MouseEvent } from "react";
import { pageHead } from "@/components/site/seo-copy";
import { salesRoles, salespersonCountries } from "@/components/site/roles";
import CandidatesView from "@/components/cl/views/CandidatesView";

export const Route = createFileRoute("/for-salespeople")({
  head: () => pageHead("/for-salespeople"),
  component: ForSalespeople,
});

function ForSalespeople() {
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const base =
    "min-height:40px;padding:0 12px;border-radius:999px;font:inherit;font-size:13px;font-weight:600;cursor:pointer;";
  const roles = salesRoles.map((label) => {
    const selected = selectedRoles.includes(label);
    return {
      label,
      pressed: selected ? "true" : "false",
      chipStyle:
        base +
        (selected
          ? "background:#FF5A3C;color:#0B2160;border:2px solid #FF5A3C"
          : "background:#0B2160;color:#FFFFFF;border:2px solid #2A4393"),
      pick: () =>
        setSelectedRoles((current) =>
          current.includes(label)
            ? current.filter((role) => role !== label)
            : current.length < 3
              ? [...current, label]
              : current,
        ),
    };
  });

  // The sign-up teaser carries what was typed over to the real account form.
  const saveSignup = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const value = (id: string) =>
      document.querySelector<HTMLInputElement | HTMLSelectElement>(`#${id}`)?.value ?? "";
    try {
      sessionStorage.setItem(
        "closdd-signup",
        JSON.stringify({
          name: value("j-name"),
          email: value("j-email"),
          roles: selectedRoles,
          years: value("j-exp"),
          country: value("j-country"),
          phone: value("j-phone"),
        }),
      );
    } catch {
      /* private mode: the account form just starts empty */
    }
    window.location.href = "/signup";
  };
  return <CandidatesView v={{ saveSignup, roles, countries: salespersonCountries }} />;
}
